import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
export var nextMidnight = function nextMidnight() {
  var midnight = new Date();
  midnight.setHours(24, 0, 0, 0);
  return midnight;
};
export var CountdownTimer =
/*#__PURE__*/
function (_Component) {
  _inherits(CountdownTimer, _Component);

  function CountdownTimer(props) {
    var _this;

    _classCallCheck(this, CountdownTimer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CountdownTimer).call(this, props));
    var countdownTo = props.countdownTo;
    var now = Date.now();
    var countdownTime = countdownTo - now;
    _this.updateTimer = _this.updateTimer.bind(_assertThisInitialized(_this));
    _this.state = {
      countdownTime: Math.max(countdownTime, 0)
    };
    return _this;
  }

  _createClass(CountdownTimer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.timer = setInterval(this.updateTimer, 1000);
      this.intervalStartTime = Date.now();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.timer);
    }
  }, {
    key: "updateTimer",
    value: function updateTimer() {
      var distance = Date.now() - this.intervalStartTime;
      var updatedCountdownTime = this.state.countdownTime - distance;

      if (updatedCountdownTime >= 0) {
        this.setState({
          countdownTime: updatedCountdownTime
        });
        this.intervalStartTime = Date.now();
      } else {
        this.setState({
          countdownTime: 0
        });
        clearInterval(this.timer);
      }
    }
  }, {
    key: "calculateTime",
    value: function calculateTime() {
      var countdownTime = this.state.countdownTime; // Time calculations for hours, minutes and seconds

      return {
        hours: Math.floor(countdownTime % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
        minutes: Math.floor(countdownTime % (1000 * 60 * 60) / (1000 * 60)),
        seconds: Math.floor(countdownTime % (1000 * 60) / 1000)
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$calculateTime = this.calculateTime(),
          hours = _this$calculateTime.hours,
          minutes = _this$calculateTime.minutes,
          seconds = _this$calculateTime.seconds;

      return React.createElement(FormattedMessage, {
        id: "count.down.timer",
        defaultMessage: "{hours}h {minutes}m {seconds}s",
        values: {
          hours: hours,
          minutes: minutes,
          seconds: seconds
        }
      });
    }
  }]);

  return CountdownTimer;
}(Component);
CountdownTimer.propTypes = {
  countdownTo: PropTypes.number.isRequired
};